import OMapLabels from './o-map-labels';

export default OMapLabels;